<template>
<v-container grid-list-xl fluid>
    <!-- Image Preview Dialog -->
    <v-dialog v-model="imagePreviewDialog" max-width="700px">
        <v-card>
            <v-card-title class="subtitle-1 py-2 px-4 d-flex justify-space-between align-center">
                <span>Chứng từ nạp tiền <span v-if="previewImageList.length > 1" class="caption grey--text">({{ activePreviewIndex + 1 }}/{{ previewImageList.length }})</span></span>
                <v-btn icon small @click="imagePreviewDialog = false">
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pa-2 text-center">
                <v-img 
                    :src="previewImageUrl" 
                    max-width="100%" 
                    max-height="450" 
                    contain
                    class="rounded"
                ></v-img>
                <div v-if="previewImageList.length > 1" class="d-flex justify-center flex-wrap mt-2">
                    <div 
                        v-for="(img, i) in previewImageList" 
                        :key="i"
                        class="ma-1 cursor-pointer"
                        :style="{ border: activePreviewIndex === i ? '2px solid #1976d2' : '2px solid transparent', borderRadius: '4px' }"
                        @click="selectPreviewImage(i)"
                    >
                        <v-img :src="img" width="50" height="40" contain class="rounded"></v-img>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
    
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.ID }}</td>
                            <td>{{ item.Username }}</td>
                            <td class="text-end">{{ item.Amount | currency}}</td>
                            <td>{{ item.TradeContent }}</td>
                            <td class="text-center">
                                <div v-if="getItemImages(item).length > 0" class="image-thumbnail-container d-inline-block">
                                    <v-badge
                                        v-if="getItemImages(item).length > 1"
                                        :content="`+${getItemImages(item).length}`"
                                        color="primary"
                                        overlap
                                        offset-x="10"
                                        offset-y="10"
                                    >
                                        <v-img 
                                            :src="getItemImages(item)[0]" 
                                            width="40" 
                                            height="40" 
                                            class="image-thumbnail elevation-1 rounded cursor-pointer"
                                            @click="showImagePreview(item)"
                                        ></v-img>
                                    </v-badge>
                                    <v-img 
                                        v-else
                                        :src="getItemImages(item)[0]" 
                                        width="40" 
                                        height="40" 
                                        class="image-thumbnail elevation-1 rounded cursor-pointer"
                                        @click="showImagePreview(item)"
                                    ></v-img>
                                </div>
                                <span v-else class="text-grey">--</span>
                            </td>
                            <td>{{ item.Method | display_value(config_methods) }}</td>
                            <td v-bind:style="{ 'color': get_type_color(item.Status, recharge_status_list)}">{{ item.Status | display_value(recharge_status_list) }}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td>{{ item.CreatedBy }}</td>
                            <td class="text-center">
                                <v-icon medium class="mr-2" color="green darken-3" @click="gotoDetail(item.ID)">fa-external-link-alt</v-icon>
                                <v-tooltip top v-if="adminRole">
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" :disabled="item.Status !== 2" medium class="mr-2" color="red darken-6" @click="requestCancelRecharge(item.ID)">fa-times-circle</v-icon>
                                    </template>
                                    <span>Hủy lệnh nạp tiền</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="total-summary-td">
                            <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{ summary.Amount | currency}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    props: {
        needRefesh: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            recharge_status_list: configs.RECHARGE_STATUS_LIST,
            recharge_status: configs.RECHARGE_STATUS,
            pagination: {...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "recharge_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogRecharge: false,
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            imagePreviewDialog: false,
            previewImageUrl: '',
            previewImageList: [],
            activePreviewIndex: 0
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        needRefesh() {
            if(this.needRefesh) {
                this.filter_data();
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.rechargeHistory.all.data,
            total_rows: state => state.rechargeHistory.all.total,
            summary: state => state.rechargeHistory.all.summary,
            loading: state => state.rechargeHistory.loading,
            currentRecharge: state => state.rechargeHistory.selected,
            configuration: state => state.configuration.selected,
        }),
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        config_methods() {
            const conf = this.configuration.ReExMethods ? JSON.parse(this.configuration.ReExMethods) : [];
            return conf.concat(configs.RECHARGE_METHODS);
        },
        headers() {
            return [{
                    text: "ID",
                    value: "ID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "User name",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Nội dung",
                    value: "TradeContent",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Chứng từ",
                    value: "ImageUrl",
                    sortable: false,
                    filterable: false,
                    align: "center",
                    width: "80px"
                },
                {
                    text: "Hình thức",
                    value: "Method",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: this.config_methods
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: configs.RECHARGE_STATUS_LIST
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Người tạo",
                    value: "CreatedBy",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ];
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("rechargeHistory/getList", param);
        },
        gotoDetail: function (id) {
            let routeData = this.$router.resolve({
                name: "RechargeDetail",
                params: {
                Pid: id,
                title: `Chi tiết nạp tiền (#${id})`
                }
            });
            window.open(routeData.href, "_blank");
        },
        requestCancelRecharge(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id, 'Bạn muốn hủy yêu cầu nạp tiền?');
        },
        cancelRecharge(rechargeId) {
            var selectedItem = _.find(this.items, {'ID': rechargeId});
            if(selectedItem) {
                selectedItem.Status = configs.RECHARGE_STATUS.Cancel;
                this.$store.dispatch("rechargeHistory/setDetail", {
                    data: {Status: configs.RECHARGE_STATUS.Cancel, Amount: selectedItem.Amount, UID: selectedItem.UID},
                    id: rechargeId,
                    cancel: true
                });
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData(username = '') {
            let routeData = this.$router.resolve({
                name: "RechargeNew",
            });
            window.open(routeData.href, "_blank");
        },
        get_type_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getItemImages(item) {
            if (item.Images) {
                if (Array.isArray(item.Images)) return item.Images;
                if (typeof item.Images === 'string') {
                    try {
                        const arr = JSON.parse(item.Images);
                        if (Array.isArray(arr) && arr.length > 0) return arr;
                    } catch (e) {
                        if (item.Images.trim()) return [item.Images.trim()];
                    }
                }
            }
            if (item.ImageUrl) return [item.ImageUrl];
            return [];
        },
        showImagePreview(item) {
            const images = this.getItemImages(item);
            if (images.length === 0) return;
            this.previewImageList = images;
            this.activePreviewIndex = 0;
            this.previewImageUrl = images[0];
            this.imagePreviewDialog = true;
        },
        selectPreviewImage(index) {
            this.activePreviewIndex = index;
            this.previewImageUrl = this.previewImageList[index];
        },
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.cancelRecharge(id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>

<style scoped>
.image-thumbnail-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-thumbnail {
    object-fit: cover;
    transition: transform 0.2s;
}

.image-thumbnail:hover {
    transform: scale(1.1);
}

.cursor-pointer {
    cursor: pointer;
}
</style>
